<template>
  <div class="mr-2 flex">
    <!-- <AssignChat icon /> -->

    <div
      v-for="(button, index) in buttons"
      :key="'option-button-' + index"
      :text="button.tooltipText"
      class="mx-1"
    >
      <b-button
        :color="button.buttonColor"
        type="filled"
        icon-pack="feather"
        @click="handleClick(button, $event)"
      >
        <feather-icon :icon="button.buttonIcon" />
      </b-button>
    </div>
  </div>
</template>

<script>
// import AssignChat from "./AssignChat";

// import leadMixin from "@/Client/Dogkart/mixins/leadMixin";

export default {
  //   mixins: [leadMixin],
  components: {
    // AssignChat,
  },
  data() {
    return {
      buttons: [
        {
          tooltipText: "Lead",
          buttonColor: "success",
          buttonIcon: "UserIcon",
        },
        // {
        //   tooltipText: "Shop",
        //   buttonColor: "success",
        //   buttonIcon: "icon-shopping-cart"
        // },
        // {
        //   tooltipText: "Track Orders",
        //   buttonColor: "success",
        //   buttonIcon: "icon-truck"
        // }
      ],
    };
  },
  methods: {
    handleClick(item, event) {
      if (!item.tooltipText) return;
      //   if (item.tooltipText === "Lead") {
      //     event.stopPropagation();
      //     this.toggleLeadSidebar(true);
      //   } else {
      this.$store.commit("dogkart/SET_CURRENT_PAGE", item.tooltipText);
      //   }
    },
  },
};
</script>
